<template>
  <NotifyComponent/>
</template>

<script>
  import NotifyComponent from '../components/NotifyComponent'

  export default {
    components: {
      NotifyComponent
    }
  }
</script>